module.exports = __webpack_public_path__ + "static/media/eva_trash-2-outline.122396e6.svg";